import { useEffect, useState } from "react";

// The server HTML and the first client render must be built from the exact same
// instant, otherwise React throws hydration error #418 (text mismatch) and
// regenerates the subtree, which shows up as flashing/blank areas while
// scrolling. Every surface that renders "now" starts from this snapshot and
// switches to the real clock right after hydration.
export const HYDRATION_SNAPSHOT = new Date("2024-01-01T12:00:00.000Z");

/**
 * Hydration-safe current time.
 * @param tickMs when > 0, refreshes on that interval after hydration.
 */
export function useNow(tickMs = 0) {
  const [now, setNow] = useState<Date>(HYDRATION_SNAPSHOT);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setNow(new Date());
    setHydrated(true);
    if (tickMs <= 0) return;
    const timer = window.setInterval(() => setNow(new Date()), tickMs);
    return () => window.clearInterval(timer);
  }, [tickMs]);

  return { now, hydrated };
}
